module.exports = __webpack_public_path__ + "static/media/fuli00.f58f384d.png";